import type {
  CreateProductItemRequest,
  InventoryItemHistoryDto,
  ProductItemDto,
  ProductItemRef,
  ProductItemTimelineDto,
  UpdateProductItemRequest,
} from '@erp-boilerplate/types';

import { api, type QueryParams } from '@/lib/api-client';

export const productItemsService = {
  list: (params: QueryParams) => api.list<ProductItemDto>('/product-items', params),
  options: (search?: string) => api.get<ProductItemRef[]>('/product-items/options', { search }),
  getById: (id: string) => api.get<ProductItemDto>(`/product-items/${id}`),
  history: (id: string) => api.get<InventoryItemHistoryDto[]>(`/product-items/${id}/history`),
  /** Every booking, hire, sale, buyback and purchase that named this piece. */
  timeline: (id: string) => api.get<ProductItemTimelineDto>(`/product-items/${id}/timeline`),
  /** Exact match on the number or barcode — the counter's way in. */
  lookup: (code: string) => api.get<ProductItemDto>('/product-items/lookup', { code }),
  create: (payload: CreateProductItemRequest) =>
    api.post<ProductItemDto>('/product-items', payload),
  update: (id: string, payload: UpdateProductItemRequest) =>
    api.patch<ProductItemDto>(`/product-items/${id}`, payload),
  remove: (id: string) => api.delete<ProductItemDto>(`/product-items/${id}`),
};
